import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiUnavailableInterceptor implements HttpInterceptor {
  private unavailableToast?: ActiveToast<any>;

  constructor(private toastr: ToastrService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isConnectionRefused(error)) {
          this.showUnavailableMessage();
        }

        return throwError(() => error);
      })
    );
  }

  private isConnectionRefused(error: HttpErrorResponse): boolean {
    const errorText = [
      error.message,
      error.statusText,
      typeof error.error === 'string' ? error.error : '',
      error.error?.message,
      error.error?.error,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return error.status === 0 || errorText.includes('connection refused');
  }

  private showUnavailableMessage(): void {
    if (this.unavailableToast) {
      return;
    }

    this.unavailableToast = this.toastr.error('Server is currently unavailable');
    this.unavailableToast.onHidden.subscribe(() => {
      this.unavailableToast = undefined;
    });
  }
}